import { FC } from 'react';
import { Grid, FormControlLabel, Checkbox, Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ActivityFormState } from 'src/types/activityFormState';

interface Props {
  formState: ActivityFormState;
  onDidRespond: (responded: boolean) => void;
  onFollowUpDateChange: (followUpDate: string | null) => void;
}

const ActivityEmailTextFields: FC<Props> = ({ formState, onDidRespond, onFollowUpDateChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <FormControlLabel
          title="If checked, the customer has reponded to this communication"
          control={<Checkbox name="didRespond" onChange={(e) => onDidRespond(e.target.checked)} checked={formState.formActivity.didRespond ?? false} size="small" />}
          label="Has Responded"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box sx={{ minWidth: '200px' }}>
          <DatePicker
            views={['year', 'month', 'day']}
            label="Follow-up Date"
            value={new Date(formState.formActivity.followUpDate) || null}
            //inputFormat={'MM-yyyy-dd'}
            onChange={(date) => onFollowUpDateChange(date.toISOString() ?? null)}
            //renderInput={(params) => <TextField {...params} />}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ActivityEmailTextFields;
